import { FunctionComponent, useContext } from "react";
import { Price } from "@kanda-libs/ks-design-library";
import LineItemContext from "components/job/LineItem/LineItemContext";

export interface TotalProps {}

const Total: FunctionComponent<TotalProps> = () => {
  const { total, classNames } = useContext(LineItemContext);

  return <Price {...classNames.total} amount={total} />;
};

export default Total;
